import { RefObject } from "react";

import { FormWrapperHandle } from "@/common/components/Entity/components/BaseEntityCreateUpdate";

export type DefaultCloseFunc = (...args: any[]) => void;

export interface UseFormDirtyGuardProps<TCloseFunc extends DefaultCloseFunc> {
  formWrapperRef: RefObject<FormWrapperHandle | null>;
  confirmMessage?: string;
  onClose: TCloseFunc | null | undefined;
}

interface Result<TCloseFunc extends DefaultCloseFunc> {
  handleClose: TCloseFunc;
}

/** COnfirm close if form is dirty (state != initial state). */
export function useFormDirtyGuard<TCloseFunc extends DefaultCloseFunc>({
  formWrapperRef,
  confirmMessage = "You have unsaved changes. Leave anyway?",
  onClose,
}: UseFormDirtyGuardProps<TCloseFunc>): Result<TCloseFunc> {
  const handleClose = ((...args: any[]) => {
    if (!onClose) {
      return;
    }

    if (!formWrapperRef.current?.formInfo?.isDirty) {
      onClose(...args);
      return;
    }

    const isConfirmed = window.confirm(confirmMessage);
    if (isConfirmed) {
      onClose(...args);
    }
  }) as TCloseFunc;

  return { handleClose };
}
